import { apiClient } from '../../gateways/api'
import type { Projectdossier } from '../types/Projectdossier'

export { patchProjectdossier }

const patchProjectdossier = async ({
  id,
  projectdossierInfo,
}: {
  id: string
  projectdossierInfo: Partial<Projectdossier>
}): Promise<Projectdossier> => {
  const { data } = await apiClient({
    url: `/rest/projectdossier/${id}`,
    method: 'PATCH',
    data: projectdossierInfo,
  })
  return data
}
